module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_3.600f2196.jpg";